import PropTypes from 'prop-types';

import Button from '#globalComponents/Button/Button';

// Disabled buttons fire no hover events, so the tooltip sits on a wrapper.
const ActionScopeButton = ({ icon, children, title, disabled = false, onClick }) => (
	<span title={title} className="inline-flex">
		<Button variant="solid" size="md" disabled={disabled} onClick={onClick}>
			{icon}
			{children}
		</Button>
	</span>
);

ActionScopeButton.propTypes = {
	icon: PropTypes.node,
	children: PropTypes.node.isRequired,
	/** Tooltip, also shown while disabled (e.g. why the action is unavailable). */
	title: PropTypes.string,
	disabled: PropTypes.bool,
	onClick: PropTypes.func.isRequired,
};

export default ActionScopeButton;
